export default "__VITE_ASSET__Cp6bO1XN__"